import { type SdkUser, WalletProviderEnum } from '@dynamic-labs/sdk-api-core';

import { getChainFromVerifiedCredentialChain } from '../../../utils/getChainFromVerifiedCredentialChain';
import type { Chain } from '../../chain/chain.types';

type UserHasEmbeddedWalletForChainProps = {
  chain: Chain;
  user: SdkUser;
};

export const userHasEmbeddedWalletForChain = ({
  user,
  chain,
}: UserHasEmbeddedWalletForChainProps): boolean => {
  const hasEmbeddedWalletForChain = user.verifiedCredentials.some(
    (vc) =>
      vc.walletProvider === WalletProviderEnum.EmbeddedWallet &&
      vc.chain &&
      getChainFromVerifiedCredentialChain(vc.chain) === chain
  );

  return hasEmbeddedWalletForChain;
};
